
    (function(){
      var rail = document.getElementById('nvQKitRail'),
          prev = document.getElementById('nvQKitPrev'),
          next = document.getElementById('nvQKitNext');
      if (!rail || !prev || !next) return;
      function step(){
        var c = rail.children[0];
        return c ? c.getBoundingClientRect().width + 12 : Math.round(rail.clientWidth * 0.8);
      }
      function go(dir){
        if (rail.scrollBy) rail.scrollBy({ left: dir * step(), behavior: 'smooth' });
        else rail.scrollLeft += dir * step();
      }
      prev.addEventListener('click', function(){ go(-1); });
      next.addEventListener('click', function(){ go(1); });
      function sync(){
        var max = rail.scrollWidth - rail.clientWidth - 2;
        prev.style.opacity = rail.scrollLeft <= 2 ? '.35' : '1';
        next.style.opacity = rail.scrollLeft >= max ? '.35' : '1';
      }
      rail.addEventListener('scroll', sync);
      window.addEventListener('resize', sync);
      sync();
    })();
    

  (function(){
    var scope = document.querySelector('.nvwt');
    if (!scope) return;
    var plans = scope.querySelectorAll('.nvwk-plan');
    var cta = document.getElementById('nvwk-cta-kit');
    var label = document.getElementById('nvwk-cta-label');
    var onetimeLink = document.getElementById('nvwk-onetime-link');
    var offerBox = document.getElementById('nvwk-offer-kit');
    var stickyBar = document.getElementById('nvwk-sticky-kit');
    var stickyPlan = document.getElementById('nvwk-sticky-plan-kit');
    var stickyPrice = document.getElementById('nvwk-sticky-price-kit');
    var stickyPerDay = document.getElementById('nvwk-sticky-perday-kit');
    var stickyCta = document.getElementById('nvwk-sticky-cta-kit');
    var VARIANT_ID = 58446266892552;
    // Delivery plans are read live from the variant's own allocations, so this
    // block works on any Novavict store and never goes stale.
    var SP_ALLOCATIONS = [{ id: 692923564296, name: "Deliver every 8 weeks, $87.00" },
{ id: 692923498760, name: "Deliver every month, $69.00" }
];
    var SELLING_PLANS = (function(){
      var m = { '1month': null, '2month': null };
      SP_ALLOCATIONS.forEach(function(p){
        var n = String(p.name || '').toLowerCase();
        if (/8\s*(wochen|weeks)|2\s*(month|monat)|zwei\s*monat/.test(n)) { m['2month'] = p.id; }
        else if (/monat|month/.test(n)) { m['1month'] = p.id; }
      });
      if (m['1month'] === null && SP_ALLOCATIONS[0]) { m['1month'] = SP_ALLOCATIONS[0].id; }
      if (m['2month'] === null && SP_ALLOCATIONS[1]) { m['2month'] = SP_ALLOCATIONS[1].id; }
      return m;
    })();
    var HAS_PLANS = SP_ALLOCATIONS.length > 0;

    function selectPlan(planKey){
      plans.forEach(function(x){ x.classList.remove('selected'); });
      var planEl = scope.querySelector('.nvwk-plan[data-plan="' + planKey + '"]');
      if (!planEl) return;
      planEl.classList.add('selected');
      if (HAS_PLANS) { label.textContent = planEl.dataset.savepct + '% off + free gifts'; }
      var saveEl = document.getElementById('nvwt-stat-save');
      if (saveEl && planEl.dataset.saveeur) { saveEl.textContent = planEl.dataset.saveeur; }
      var wasEl = document.getElementById('nvwt-stat-was');
      if (wasEl && planEl.dataset.was) { wasEl.textContent = planEl.dataset.was; }
      var perDayEl = planEl.querySelector('.nvwk-plan-perday');
      var nameEl = planEl.querySelector('.nvwk-plan-name');
      var nowEl = planEl.querySelector('.nvwk-plan-now');
      stickyPlan.textContent = nameEl ? nameEl.textContent : '';
      stickyPrice.textContent = nowEl ? nowEl.textContent : '';
      stickyPerDay.textContent = perDayEl ? perDayEl.textContent : '';
    }


    if (!HAS_PLANS) {
      offerBox.classList.add('nvwk-noplans');
      label.textContent = 'One-time purchase — $113.99';
    }
    plans.forEach(function(p){
      p.addEventListener('click', function(){ selectPlan(p.dataset.plan); });
    });

    scope.querySelectorAll('.nvwk-future-pill').forEach(function(pill){
      pill.addEventListener('click', function(){
        pill.classList.toggle('open');
        pill.nextElementSibling.classList.toggle('open');
      });
    });

    function addToCart(sellingPlan, triggerEl){
      var item = { id: VARIANT_ID, quantity: 1 };
      if (sellingPlan) item.selling_plan = sellingPlan;

      triggerEl.disabled = true;
      var isMainCta = (triggerEl === cta);
      var originalText = isMainCta ? label.textContent : triggerEl.textContent;
      if (isMainCta) { label.textContent = 'Adding …'; } else { triggerEl.textContent = 'Adding …'; }

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: [item] })
      })
      .then(function(res){
        if (!res.ok) return res.json().then(function(err){ throw new Error(err.description || 'Could not be added to the cart.'); });
        return res.json();
      })
      .then(function(){
        window.location.href = '/cart';
      })
      .catch(function(err){
        triggerEl.disabled = false;
        if (isMainCta) { label.textContent = originalText; } else { triggerEl.textContent = originalText; }
        alert(err.message || 'Something went wrong adding this to your cart.');
      });
    }

    cta.addEventListener('click', function(){
      var selected = scope.querySelector('.nvwk-plan.selected');
      var plan = selected ? selected.dataset.plan : '2month';
      addToCart(SELLING_PLANS[plan], cta);
    });

    onetimeLink.addEventListener('click', function(){
      addToCart(null, onetimeLink);
    });

    stickyCta.addEventListener('click', function(){
      offerBox.scrollIntoView({ behavior: 'smooth', block: 'center' });
      offerBox.classList.remove('nvwk-highlight');
      void offerBox.offsetWidth;
      offerBox.classList.add('nvwk-highlight');
      setTimeout(function(){ offerBox.classList.remove('nvwk-highlight'); }, 1000);
    });

    if ('IntersectionObserver' in window) {
      var observer = new IntersectionObserver(function(entries){
        entries.forEach(function(entry){
          if (entry.isIntersecting) { stickyBar.classList.remove('show'); }
          else { stickyBar.classList.add('show'); }
        });
      }, { threshold: 0 });
      observer.observe(cta);
    }
  })();
  

(function(){
  document.querySelectorAll('.nqa-btn').forEach(function(btn){
    btn.addEventListener('click',function(){
      var item=btn.closest('.nqa-item');
      var isOpen=item.classList.contains('open');
      item.closest('.nqa-wrap').querySelectorAll('.nqa-item').forEach(function(i){i.classList.remove('open');});
      if(!isOpen)item.classList.add('open');
    });
  });
})();


(function(){
var hero = document.getElementById('nvkHero');
if(!hero) return;
var ORDER = ['nvkPress','nvkBox','nvkStory','nvkTrust','nvkComments','nvkFaq','nvkOutcome','nvkUse','nvkReviews','nvkScience','nvkSheet','nvkGuarantee','nvkOffer','nvkClose'];
var target = null;
function ready(){
hero.classList.add('is-ready');
ORDER.forEach(function(id){
var n = document.getElementById(id);
if(n) n.classList.add('is-ready');
});
}
function place(){
if(hero.dataset.placed) return;
var info = document.querySelector('.product-information');
var sec = info ? info.closest('.shopify-section') : null;
if(sec && sec.parentNode){
sec.parentNode.insertBefore(hero, sec);
var after = sec;
ORDER.forEach(function(id){
var n = document.getElementById(id);
if(n){ after.parentNode.insertBefore(n, after.nextSibling); after = n; }
});
target = sec;
hero.dataset.placed = '1';
}
ready();
}
place();
if(!hero.dataset.placed){
document.addEventListener('DOMContentLoaded', place);
setTimeout(place, 1200);
}
setTimeout(ready, 1500);
function toOffer(){
var to = target || document.querySelector('.product-information');
if(!to) return;
var y = to.getBoundingClientRect().top + window.pageYOffset - 16;
window.scrollTo({ top: y, behavior: 'smooth' });
}
['nvkHeroCta','nvkBoxCta','nvkUseCta','nvkSciCta','nvkGuaCta','nvkOffCta','nvkClsCta'].forEach(function(id){
var b = document.getElementById(id);
if(b) b.addEventListener('click', toOffer);
});
[['nvkRevRail','nvkRevPrev','nvkRevNext',22],['nvkSciRail','nvkSciPrev','nvkSciNext',20]].forEach(function(t){
var rail = document.getElementById(t[0]),
prev = document.getElementById(t[1]),
next = document.getElementById(t[2]),
gap = t[3];
if(!rail || !prev || !next) return;
function step(){
var c = rail.children[0];
return c ? c.getBoundingClientRect().width + gap : Math.round(rail.clientWidth * 0.9);
}
function go(dir){
if(rail.scrollBy) rail.scrollBy({ left: dir * step(), behavior: 'smooth' });
else rail.scrollLeft += dir * step();
}
prev.addEventListener('click', function(){ go(-1); });
next.addEventListener('click', function(){ go(1); });
function sync(){
var max = rail.scrollWidth - rail.clientWidth - 2;
prev.style.opacity = rail.scrollLeft <= 2 ? '.35' : '1';
next.style.opacity = rail.scrollLeft >= max ? '.35' : '1';
}
rail.addEventListener('scroll', sync);
window.addEventListener('resize', sync);
sync();
});
})();
